import clsx from 'clsx';
import type React from 'react';

import type * as hiveCore from '@gitbook/hive-core';
import { TextSkeleton } from '@gitbook/spine-react';

import { PageCoverSkeleton, PageDocumentSkeleton } from './PageDocumentSkeleton';

/**
 * Skeleton for the page body.
 */
export function PageSkeleton(props: {
    header?: React.ReactNode;
    cover?: hiveCore.RevisionPageDocument['cover'];
}) {
    const { header, cover } = props;

    return (
        <div className="flex flex-1 flex-col">
            {cover ? <PageCoverSkeleton height={cover.height ?? 240} /> : null}
            <div className="flex flex-1 flex-col px-6 py-8 md:px-24">
                <div className="mx-auto flex w-full max-w-[--block-wrapper-max-width] flex-col">
                    {header}
                    <div className={clsx('flex flex-col gap-6 pb-6', header ? 'pt-0' : 'pt-6')}>
                        <TextSkeleton className="text-content-page-title-medium lg:text-content-page-title-large">
                            Title of the page
                        </TextSkeleton>
                        <PageDocumentSkeleton />
                    </div>
                </div>
            </div>
        </div>
    );
}
